
    export default 
    {
    "top_stores": {
        "store_authorized_tip": "Der Shop muss neu autorisiert werden. Bitte gehen Sie zu Einstellungen - Konto, um die Autorisierung zu aktualisieren. Andernfalls können Sie den Shop nicht ordnungsgemäß mit DSers betreiben."
    }
}